import { yupResolver } from "@hookform/resolvers/yup";
import LoadingFormNormal from "components/shared-components/LoadingFormNormal";
import MessageFormValidate from "components/shared-components/MessageFormValidate";
import {
  APPROVE_RADIO_VALUE,
  generateYupSchemaTableField,
  REGISTRY_INVOICE_FIELD,
} from "constants/FormatDataContanst";
import { english } from "flatpickr/dist/l10n/default";
import { Vietnamese } from "flatpickr/dist/l10n/vn";
import "flatpickr/dist/themes/material_blue.css";
import {
  generateCheckboxGroupApprove,
  generateDateField,
  generateDateFieldArray,
  generateInputField,
  generateInputFieldArray,
  generateRadioField,
  generateRadioGroupApprove,
  generateSelectField,
  generateSelectFieldArray,
  generateTableV2,
  OPTION_FIELD,
} from "helpers/form_helper_old";
import PropTypes from "prop-types";
import React, { useEffect, useMemo, useRef, useState } from "react";
import { useFieldArray, useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import { useToasts } from "react-toast-notifications";
import {
  Button,
  Col,
  Dropdown,
  DropdownItem,
  DropdownMenu,
  DropdownToggle,
  FormGroup,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Table,
} from "reactstrap";
import {
  checkInvoicesCurrent,
  createRegistryInvoices,
  downloadPDFInvoices,
  downloadXmlRegistryInvoices,
  editRegistryInvoices,
  getDetailRegistryInvoices,
  previewPdfRegisterInvoice,
  resetPreviewPdfRegisterInvoice,
} from "store/actions";
import {
  DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL,
  DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS,
} from "store/data-format/actionTypes";
import * as yup from "yup";
import "../detailData.scss";
import {
  convertDate,
  formatTimestampToDate,
  initOptionDateLocale,
  MODE_FORM,
} from "../utils";
const CQTQLY_JSON = require("./CQTQLY.json");

const LCS_INFO = {
  ten: "Công ty TNHH L.C.S",
  mst: "0302999571",
};

const DetailData = props => {
  const { isOpen, toggle, dataDetail, t, i18n, toggleReleaseModal } = props;
  const [optionDateLocale, setOptionDateLocale] = useState({
    ...initOptionDateLocale,
  });

  const dataFormat = useSelector(state => state.dataFormat);
  const { listSignInfo, loadListMethodSign } = useSelector(
    state => state.Dashboard
  );
  const modal = useRef(null);
  const [disableForm, setDisableForm] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const { previewPdfRegisterFile, type, fileDownload, fileDownloadName } =
    dataFormat;
  const [dataDetails, setDataDetails] = useState();
  const { addToast } = useToasts();
  const toggleDropdown = () => {
    setDropdownOpen(!dropdownOpen);
  };
  useEffect(() => {
    if (
      previewPdfRegisterFile &&
      previewPdfRegisterFile.data &&
      previewPdfRegisterFile.typePreview !== "popupType"
    ) {
      const link = document.createElement("a");
      link.href = previewPdfRegisterFile.data;
      link.setAttribute("download", "Invoice.pdf");
      document.body.appendChild(link);
      link.click();
      console.log(previewPdfRegisterFile, "previewPdfRegisterFile");
      addToast("Tải xuống thành công", {
        appearance: "success",
        autoDismiss: true,
      });
    } else {
      if (previewPdfRegisterFile && previewPdfRegisterFile.error) {
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
      }
    }
  }, [previewPdfRegisterFile]);
  // Language Change
  useEffect(() => {
    const lang = i18n.language;
    switch (lang) {
      case "vn":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...Vietnamese,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      case "en":
        setOptionDateLocale({
          ...optionDateLocale,
          locale: {
            ...english,
            firstDayOfWeek: optionDateLocale.locale.firstDayOfWeek,
          },
        });
        break;
      default:
        break;
    }
  }, [t]);

  const dispatch = useDispatch();
  // store reducer
  useEffect(() => {
    if (isOpen) {
      dispatch(checkInvoicesCurrent());
    }
  }, [isOpen]);

  const {
    loading: loadingDetail,
    data: detailRegistryInvoices,
    error,
  } = dataFormat.detailRegistryInvoices;
  const {
    loading: loadingInvoiceCurrent,
    data: invoiceCurrent,
    error: errorInvoiceCurrent,
  } = dataFormat.checkInvoiceCurrent;

  const { loading: loadingSubmitCreate, error: errorSubmitCreate } =
    dataFormat.createRegistryInvoices;
  const { loading: loadingSubmitEdit, error: errorSubmitEdit } =
    dataFormat.editRegistryInvoices;

  const COMMON_FIELD = REGISTRY_INVOICE_FIELD.COMMON;
  const INFO_DETAIL_FIELD = REGISTRY_INVOICE_FIELD.INFO_DETAIL;
  const LIST_CA_FIELD = REGISTRY_INVOICE_FIELD.LIST_CA;

  const LIST_TTTCGP_FIELD = REGISTRY_INVOICE_FIELD.TTTCGP;
  const LIST_TTTCTN_FIELD = REGISTRY_INVOICE_FIELD.TTTCTN;

  const LIST_TTDVHTPT_FIELD = REGISTRY_INVOICE_FIELD.TTDVHTPT;
  const LIST_TTTNSDung_FIELD = REGISTRY_INVOICE_FIELD.TTTNSDung;
  const LIST_TTDKTH_FIELD = REGISTRY_INVOICE_FIELD.TTDKTH;

  useEffect(() => {
    if (isOpen) {
      checkDisableForm();
      reset();
      if (dataDetail?.id) {
        dispatch(getDetailRegistryInvoices(dataDetail.id));
      } else {
        setTimeout(() => {
          setValue(INFO_DETAIL_FIELD.CMA.field, true);
          //   setValue(INFO_DETAIL_FIELD.NNTDBKKHAN.field, false);
          setValue(INFO_DETAIL_FIELD.CDDU.field, true);
          setValue(INFO_DETAIL_FIELD.CBTHOP.field, false);
          addNewLineTTTCGP();
          addNewLineTTTCTN();
        });
      }
      setTimeout(() => {
        if (modal && modal.current) {
          modal.current.scrollTop = 0;
          if (!dataDetail.id) {
            addNewLine();
          }
          setFocus(COMMON_FIELD.TNNT.field);
        }
      });
    }
  }, [isOpen]);

  useEffect(() => {
    switch (type) {
      case DOWNLOAD_PDF_REGISTRY_INVOICES_SUCCESS: {
        if (fileDownload !== null) {
          const link = document.createElement("a");
          link.href = fileDownload;
          link.setAttribute("download", fileDownloadName);
          document.body.appendChild(link);
          console.log(link, "link");
          link.click();
        }
        addToast("Tải xuống thành công", {
          appearance: "success",
          autoDismiss: true,
        });
        dispatch(resetPreviewPdfRegisterInvoice());
        break;
      }
      case DOWNLOAD_PDF_REGISTRY_INVOICES_FAIL: {
        addToast("Tải xuống thất bại", {
          appearance: "error",
          autoDismiss: true,
        });
        dispatch(resetPreviewPdfRegisterInvoice());
      }
      default:
        break;
    }
  }, [type]);

  const checkDisableForm = () => {
    if (dataDetail?.mode === MODE_FORM.VIEW) {
      setDisableForm(true);
    } else {
      setDisableForm(false);
    }
  };

  useEffect(() => {
    if (!isOpen) {
      setDataDetails(null);
    }
  }, [invoiceCurrent, isOpen]);

  useEffect(() => {
    if (
      invoiceCurrent &&
      invoiceCurrent.result &&
      invoiceCurrent.items &&
      dataDetail?.mode === MODE_FORM.ADD
    ) {
      invoiceCurrent.items.nlap = new Date().getTime() / 1000;
      setDataDetails(invoiceCurrent.items);
    } else {
      if (detailRegistryInvoices && dataDetail?.mode !== MODE_FORM.ADD) {
        setDataDetails({
          ...detailRegistryInvoices,
          //TODO: REMOVE after TEST
          // [COMMON_FIELD.TNDDPLuat.field]: "Nguyễn Văn A",
          // [COMMON_FIELD.DTDDPLuat.field]: "0909090909",
          // [COMMON_FIELD.CCCDan.field]: "1234567890",
          // [COMMON_FIELD.SHChieu.field]: "1234567890",
          // [COMMON_FIELD.NSDDPL.field]: 1748416287,
          // [COMMON_FIELD.GTinh.field]: 0,
          // [INFO_DETAIL_FIELD.CQXLTSCong.field]: 0,
          // [INFO_DETAIL_FIELD.HDGTGTTHBLai.field]: "1",
          // [INFO_DETAIL_FIELD.HDBHTHBLai.field]: "1",
          // [INFO_DETAIL_FIELD.HDTMai.field]: "1",
          //TODO: REMOVE after TEST
        });
      }
    }
  }, [invoiceCurrent, detailRegistryInvoices]);

  const loadDataTableFromDetail = ({ field, data }) => {
    setValue(
      field,
      data.map(item => {
        const tngay = formatTimestampToDate(item.tngay);
        const dngay = formatTimestampToDate(item.dngay);
        let khmshdonOption = null;
        if (item?.khmshdon) {
          let khmshdonValue = Number(item?.khmshdon);
          khmshdonOption = OPTION_FIELD?.khmshdon?.find(
            item => Number(item.value) == khmshdonValue
          );
        }
        return {
          ...item,
          tngay: [tngay, dngay],
          dngay: undefined,
          khmshdon: khmshdonOption,
        };
      })
    );
  };

  useEffect(() => {
    if (dataDetails && isOpen) {
      // Set default value COMMON_FIELD
      setDefaultValue(COMMON_FIELD);
      // Set default value INFO_DETAIL_FIELD
      setDefaultValue(INFO_DETAIL_FIELD, true);
      // Set default value listCAS
      const {
        registryInvoiceCas,
        registryInvoiceTcgp,
        registryInvoiceTctn,
        registryInvoiceDvhtpt,
        registryInvoiceTnsdung,
        registryInvoiceDkth,
      } = dataDetails;
      if (registryInvoiceCas && registryInvoiceCas?.length > 0) {
        setValue(
          LIST_CA_FIELD.field,
          registryInvoiceCas.map(item => {
            const tngay = formatTimestampToDate(item.tngay);
            const dngay = formatTimestampToDate(item.dngay);
            return {
              ttchuc: item.ttchuc,
              seri: item.seri,
              tngay: [tngay, dngay],
              hthuc: OPTION_CA_HTHUC.find(
                option => Number(option.value) === Number(item.hthuc)
              ),
            };
          })
        );
      }
      if (registryInvoiceTcgp && registryInvoiceTcgp?.length > 0) {
        loadDataTableFromDetail({
          field: LIST_TTTCGP_FIELD.field,
          data: registryInvoiceTcgp,
        });
      }
      if (registryInvoiceTctn && registryInvoiceTctn?.length > 0) {
        loadDataTableFromDetail({
          field: LIST_TTTCTN_FIELD.field,
          data: registryInvoiceTctn,
        });
      }
      if (registryInvoiceDvhtpt && registryInvoiceDvhtpt?.length > 0) {
        loadDataTableFromDetail({
          field: LIST_TTDVHTPT_FIELD.field,
          data: registryInvoiceDvhtpt,
        });
      }
      if (registryInvoiceTnsdung && registryInvoiceTnsdung?.length > 0) {
        loadDataTableFromDetail({
          field: LIST_TTTNSDung_FIELD.field,
          data: registryInvoiceTnsdung,
        });
      }
      if (registryInvoiceDkth && registryInvoiceDkth?.length > 0) {
        loadDataTableFromDetail({
          field: LIST_TTDKTH_FIELD.field,
          data: registryInvoiceDkth,
        });
      }
    }
  }, [detailRegistryInvoices, invoiceCurrent, dataDetails, isOpen]);

  // Custom set default value
  const setDefaultValue = (FIELDS, isTimeOut = false) => {
    for (const key in FIELDS) {
      const finalKey = FIELDS[key].field;
      const type = FIELDS[key].type;
      let finalValue = dataDetails[finalKey];
      if (finalValue) {
        switch (type) {
          case "select":
            const option = OPTION_GROUP[finalKey];

            let valueSelect = null;
            if (finalKey === COMMON_FIELD.CQTQLY.field) {
              valueSelect = option.find(item => item.value === finalValue);
            } else if (finalKey === COMMON_FIELD.HTHUC.field) {
              valueSelect = option.find(
                item => Number(item.value) === Number(finalValue)
              );
            }
            if (valueSelect) {
              setValue(finalKey, valueSelect);
            } else {
              setValue(finalKey, {
                value: finalValue,
                label: finalValue,
                code: "",
              });
            }
            break;
          case "radioField":
            setValue(finalKey, finalValue);
            break;
          case "radio":
          case "checkbox":
            if (
              isTimeOut &&
              (LIST_HTGDLHĐĐT_CMA_RADIO.findIndex(
                item => item.field === finalKey
              ) !== -1 ||
                LIST_HTGDLHĐĐT_KCMA_RADIO.findIndex(
                  item => item.field === finalKey
                ) !== -1)
            ) {
              setTimeout(() => {
                finalValue = Number(finalValue) === 1 ? true : false;
                setValue(finalKey, finalValue);
              });
            } else {
              finalValue = Number(finalValue) === 1 ? true : false;
              setValue(finalKey, finalValue);
            }
            break;
          case "text":
            setValue(finalKey, finalValue);
            break;
          case "date":
            const date = formatTimestampToDate(finalValue);
            setValue(finalKey, [date]);
            break;
        }
      }
    }
  };

  const schemaListTTTCGP = generateYupSchemaTableField({
    fieldConstant: LIST_TTTCGP_FIELD.field,
    listConstant: LIST_TTTCGP_FIELD,
    t,
    yup,
  });

  const schemaListTTTCTN = generateYupSchemaTableField({
    fieldConstant: LIST_TTTCTN_FIELD.field,
    listConstant: LIST_TTTCTN_FIELD,
    t,
    yup,
  });

  const schemaListTTDVHTPT = generateYupSchemaTableField({
    fieldConstant: LIST_TTDVHTPT_FIELD.field,
    listConstant: LIST_TTDVHTPT_FIELD,
    t,
    yup,
  });

  const schemaListTTTNSDung = generateYupSchemaTableField({
    fieldConstant: LIST_TTTNSDung_FIELD.field,
    listConstant: LIST_TTTNSDung_FIELD,
    t,
    yup,
  });

  const schemaListTTDKTH = generateYupSchemaTableField({
    fieldConstant: LIST_TTDKTH_FIELD.field,
    listConstant: LIST_TTDKTH_FIELD,
    t,
    yup,
  });

  const schema = {
    // THông tin chung
    [COMMON_FIELD.PBAN.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.PBAN.field}`),
        })
      )
      .max(
        COMMON_FIELD.PBAN.max,
        t("form.validate.char_max", { max: COMMON_FIELD.PBAN.max })
      ),
    [COMMON_FIELD.MSO.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.MSO.field}`),
        })
      )
      .max(
        COMMON_FIELD.MSO.max,
        t("form.validate.char_max", { max: COMMON_FIELD.MSO.max })
      ),
    [COMMON_FIELD.TEN.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.TEN.field}`),
        })
      )
      .max(
        COMMON_FIELD.TEN.max,
        t("form.validate.char_max", { max: COMMON_FIELD.TEN.max })
      ),
    [COMMON_FIELD.HTHUC.field]: yup.object().required(
      t("form.validate.select", {
        title: t(`field.${COMMON_FIELD.HTHUC.field}`),
      })
    ),
    [COMMON_FIELD.TNNT.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.TNNT.field}`),
        })
      )
      .max(
        COMMON_FIELD.TNNT.max,
        t("form.validate.char_max", { max: COMMON_FIELD.TNNT.max })
      ),
    [COMMON_FIELD.MST.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.MST.field}`),
        })
      )
      .test("len", "Vui lòng nhập 10 hoặc 14 ký tự", val => {
        return val.length === 0 || val.length === 10 || val.length === 14;
      }),
    [COMMON_FIELD.CQTQLY.field]: yup.object().required(
      t("form.validate.select", {
        title: t(`field.${COMMON_FIELD.CQTQLY.field}`),
      })
    ),
    //   .max(
    //     COMMON_FIELD.CQTQLY.max,
    //     t("form.validate.char_max", { max: COMMON_FIELD.CQTQLY.max })
    //   ),
    [COMMON_FIELD.MCQTQLY.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.MCQTQLY.field}`),
        })
      )
      .test(
        "len",
        "Vui lòng nhập đủ 5 ký tự",
        val => val.length === 0 || val.length === 5
      )
      .max(
        COMMON_FIELD.MCQTQLY.max,
        t("form.validate.char_max", { max: COMMON_FIELD.MCQTQLY.max })
      ),
    [COMMON_FIELD.NLHE.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.NLHE.field}`),
        })
      )
      .max(
        COMMON_FIELD.NLHE.max,
        t("form.validate.char_max", { max: COMMON_FIELD.NLHE.max })
      ),
    [COMMON_FIELD.DCLHE.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DCLHE.field}`),
        })
      )
      .max(
        COMMON_FIELD.DCLHE.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DCLHE.max })
      ),
    [COMMON_FIELD.DCTDTU.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DCTDTU.field}`),
        })
      )
      .email(
        t("form.validate.invalid", {
          title: t(`field.${COMMON_FIELD.DCTDTU.field}`),
        })
      )
      .max(
        COMMON_FIELD.DCTDTU.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DCTDTU.max })
      ),
    [COMMON_FIELD.DTLHE.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DTLHE.field}`),
        })
      )
      .max(
        COMMON_FIELD.DTLHE.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DTLHE.max })
      ),
    [COMMON_FIELD.DDANH.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DDANH.field}`),
        })
      )
      .max(
        COMMON_FIELD.DDANH.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DDANH.max })
      ),
    [COMMON_FIELD.NLAP.field]: yup.array().min(
      1,
      t("form.validate.select", {
        title: t(`field.${COMMON_FIELD.NLAP.field}`),
      })
    ),
    // Nội dung tờ khai
    //HTHDon chứa hình thức hóa đơn áp dụng
    [INFO_DETAIL_FIELD.CMA.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.KCMA.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    //HTGDLHĐĐT chứa hình thức gửi dữ liệu
    [INFO_DETAIL_FIELD.NNTDBKKHAN.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.NNTKTDNUBND.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.CDLTTDCQT.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.CDLQTCTN.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    //PThuc chứa phương thức chuyển dữ liệu HĐĐT
    [INFO_DETAIL_FIELD.CDDU.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.CBTHOP.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    //LHDSDung chứa loại hóa đơn sử dụng
    [INFO_DETAIL_FIELD.HDGTGT.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.HDBHANG.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.HDBTSCONG.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.HDBHDTQGIA.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.HDKHAC.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.CTU.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.CMTMTTIEN.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    // Thông tin chứng thư số sử dụng
    [LIST_CA_FIELD.field]: yup
      .array()
      .min(1, t("form.validate.least_one_line"))
      .of(
        yup.object().shape({
          [LIST_CA_FIELD.TTCHUC.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(`field.listCAs.${LIST_CA_FIELD.TTCHUC.field}`),
              })
            )
            .max(
              LIST_CA_FIELD.TTCHUC.max,
              t("form.validate.char_max", { max: LIST_CA_FIELD.TTCHUC.max })
            ),
          [LIST_CA_FIELD.SERI.field]: yup
            .string()
            .required(
              t("form.validate.required", {
                title: t(`field.listCAs.${LIST_CA_FIELD.SERI.field}`),
              })
            )
            .max(
              LIST_CA_FIELD.SERI.max,
              t("form.validate.char_max", { max: LIST_CA_FIELD.SERI.max })
            )
            .test("uniqueSeri", "Cert seri không được trùng nhau", val => {
              const listCAsValue = watch("listCAs");
              const count = listCAsValue.filter(
                x => x.seri.toLowerCase() === val.toLowerCase()
              ).length;
              if (count > 1) {
                return false;
              } else {
                return true;
              }
            }),
          [LIST_CA_FIELD.HTHUC.field]: yup.object().required(
            t("form.validate.select", {
              title: t(`field.listCAs.${LIST_CA_FIELD.HTHUC.field}`),
            })
          ),
          [LIST_CA_FIELD.TNGAY.field]: yup.array().min(
            2,
            t("form.validate.select", {
              title: t(`field.listCAs.timeUse`),
            })
          ),
        })
      ),
    checkLHDSDung: yup
      .boolean()
      .test("len", "Vui lòng chọn ít nhất 1 loại hóa đơn", val => {
        let check = false;
        if (
          getValues(INFO_DETAIL_FIELD.HDGTGT.field) ||
          getValues(INFO_DETAIL_FIELD.HDBHANG.field) ||
          getValues(INFO_DETAIL_FIELD.HDBTSCONG.field) ||
          getValues(INFO_DETAIL_FIELD.HDBHDTQGIA.field) ||
          getValues(INFO_DETAIL_FIELD.HDKHAC.field) ||
          getValues(INFO_DETAIL_FIELD.CTU.field) ||
          getValues(INFO_DETAIL_FIELD.HDGTGTTHBLai.field) ||
          getValues(INFO_DETAIL_FIELD.HDBHTHBLai.field) ||
          getValues(INFO_DETAIL_FIELD.HDTMai.field)
        ) {
          check = true;
        }
        return check;
      }),
    [COMMON_FIELD.TNDDPLuat.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.TNDDPLuat.field}`),
        })
      )
      .max(
        COMMON_FIELD.TNDDPLuat.max,
        t("form.validate.char_max", { max: COMMON_FIELD.TNDDPLuat.max })
      ),
    [COMMON_FIELD.DTDDPLuat.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.DTDDPLuat.field}`),
        })
      )
      .max(
        COMMON_FIELD.DTDDPLuat.max,
        t("form.validate.char_max", { max: COMMON_FIELD.DTDDPLuat.max })
      ),
    [COMMON_FIELD.CCCDan.field]: yup
      .string()
      .required(
        t("form.validate.required", {
          title: t(`field.${COMMON_FIELD.CCCDan.field}`),
        })
      )
      .max(
        COMMON_FIELD.CCCDan.max,
        t("form.validate.char_max", { max: COMMON_FIELD.CCCDan.max })
      ),
    [COMMON_FIELD.SHChieu.field]: yup
      .string()
      .max(
        COMMON_FIELD.SHChieu.max,
        t("form.validate.char_max", { max: COMMON_FIELD.SHChieu.max })
      ),
    [COMMON_FIELD.NSDDPL.field]: yup.array().min(
      1,
      t("form.validate.required", {
        title: t(`field.${COMMON_FIELD.NSDDPL.field}`),
      })
    ),
    [COMMON_FIELD.GTinh.field]: yup.number(),
    [INFO_DETAIL_FIELD.CQXLTSCong.field]: yup.number(),
    [INFO_DETAIL_FIELD.HDGTGTTHBLai.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.HDBHTHBLai.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
    [INFO_DETAIL_FIELD.HDTMai.field]: yup
      .boolean()
      .oneOf([APPROVE_RADIO_VALUE.APPROVE, APPROVE_RADIO_VALUE.NOT_APPROVE]),
  };

  const finalSchema = useMemo(() => {
    return yup.object().shape({
      ...schema,
      [LIST_TTTCGP_FIELD.field]: yup.array().of(schemaListTTTCGP),
      [LIST_TTTCTN_FIELD.field]: yup.array().of(schemaListTTTCTN),

      [LIST_TTDVHTPT_FIELD.field]: yup.array().of(schemaListTTDVHTPT),
      [LIST_TTTNSDung_FIELD.field]: yup.array().of(schemaListTTTNSDung),
      [LIST_TTDKTH_FIELD.field]: yup.array().of(schemaListTTDKTH),
    });
  }, [
    schema,
    schemaListTTDVHTPT,
    schemaListTTTNSDung,
    schemaListTTDKTH,
    schemaListTTTCGP,
    schemaListTTTCTN,
  ]);

  const {
    handleSubmit,
    reset,
    formState: { errors, touchedFields, isSubmitting },
    control,
    setValue,
    getValues,
    setError,
    register,
    unregister,
    trigger,
    watch,
    setFocus,
  } = useForm({
    resolver: yupResolver(finalSchema),
    mode: "all",
    reValidateMode: "onChange",
    defaultValues: {
      [COMMON_FIELD.PBAN.field]: "2.0.0",
      [COMMON_FIELD.MSO.field]: "01/ĐKTĐ-HĐĐT",
      [COMMON_FIELD.MST.field]: "",
      [COMMON_FIELD.NLAP.field]: [new Date()],
      [COMMON_FIELD.TEN.field]:
        "Tờ khai đăng ký/thay đổi thông tin sử dụng hóa đơn điện tử",
      [INFO_DETAIL_FIELD.CMA.field]: APPROVE_RADIO_VALUE.APPROVE,
      [INFO_DETAIL_FIELD.KCMA.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,

      [INFO_DETAIL_FIELD.NNTDBKKHAN.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,
      [INFO_DETAIL_FIELD.NNTKTDNUBND.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,

      [INFO_DETAIL_FIELD.CDLQTCTN.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,
      [INFO_DETAIL_FIELD.CDLTTDCQT.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,

      [INFO_DETAIL_FIELD.CDDU.field]: APPROVE_RADIO_VALUE.APPROVE,
      [INFO_DETAIL_FIELD.CBTHOP.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,
      [COMMON_FIELD.MCQTQLY.field]: "",

      [COMMON_FIELD.TNDDPLuat.field]: "",
      [COMMON_FIELD.DTDDPLuat.field]: "",
      [COMMON_FIELD.CCCDan.field]: "",
      [COMMON_FIELD.SHChieu.field]: "",
      [COMMON_FIELD.NSDDPL.field]: [],
      [COMMON_FIELD.GTinh.field]: 0,
      [INFO_DETAIL_FIELD.CQXLTSCong.field]: 0,
      [LIST_CA_FIELD.field]: [],
      [LIST_TTTCGP_FIELD.field]: [],
      [LIST_TTTCTN_FIELD.field]: [],
      [LIST_TTDVHTPT_FIELD.field]: [],
      [LIST_TTTNSDung_FIELD.field]: [],
      [LIST_TTDKTH_FIELD.field]: [],

      //   [INFO_DETAIL_FIELD.HDGTGT.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,
      //   [INFO_DETAIL_FIELD.HDBHANG.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,
      //   [INFO_DETAIL_FIELD.HDBTSCONG.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,
      //   [INFO_DETAIL_FIELD.HDBHDTQGIA.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,
      //   [INFO_DETAIL_FIELD.HDKHAC.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,
      //   [INFO_DETAIL_FIELD.CTU.field]: APPROVE_RADIO_VALUE.NOT_APPROVE,
    },
  });

  const { listCAs, listTTDVHTPT } = watch();

  useEffect(() => {
    if (errors) {
      console.log("🚀 ~ useEffect ~ errors:", errors);
    }
  }, [errors]);

  const OPTION_HTHUC = [
    {
      value: COMMON_FIELD.HTHUC.selectValues.ADD,
      label: t("select.hthuc_add"),
    },
    {
      value: COMMON_FIELD.HTHUC.selectValues.EDIT,
      label: t("select.hthuc_edit"),
    },
  ];

  const OPTION_CA_HTHUC = [
    {
      value: LIST_CA_FIELD.HTHUC.selectValues.ADD,
      label: t("select.add"),
    },
    {
      value: LIST_CA_FIELD.HTHUC.selectValues.EXTEND,
      label: t("select.extend"),
    },
    {
      value: LIST_CA_FIELD.HTHUC.selectValues.STOP_USE,
      label: t("select.stopUse"),
    },
  ];

  const OPTION_CQTQLY = Object.entries(CQTQLY_JSON).map(([key, value]) => {
    return {
      value: value,
      label: key + " - " + value,
      code: key,
    };
  });

  const OPTION_GROUP = {
    [COMMON_FIELD.HTHUC.field]: OPTION_HTHUC,
    [COMMON_FIELD.CQTQLY.field]: OPTION_CQTQLY,
  };

  // 1. Giới tính:
  const LIST_GTinh_RADIO = [
    {
      value: 0,
      label: "Nữ",
    },
    {
      value: 1,
      label: "Nam",
    },
  ];

  const LIST_USED_RADIO = [
    {
      value: 0,
      label: "Không sử dụng",
    },
    {
      value: 1,
      label: "Sử dụng",
    },
  ];

  // 1. Hình thức hóa đơn:
  const LIST_HTHD_RADIO = [
    {
      field: INFO_DETAIL_FIELD.CMA.field,
      label: t(`field.${INFO_DETAIL_FIELD.CMA.field}`),
      isDisable: false,
    },
    {
      field: INFO_DETAIL_FIELD.KCMA.field,
      label: t(`field.${INFO_DETAIL_FIELD.KCMA.field}`),
      isDisable: false,
    },
  ];
  // 1.1 Hđ từ MTT
  const HĐTT_CHECKBOX = [
    {
      field: INFO_DETAIL_FIELD.CMTMTTIEN.field,
      label: t(`field.${INFO_DETAIL_FIELD.CMTMTTIEN.field}`),
    },
  ];
  // 2. Hình thức gửi dữ liệu hóa đơn điện tử (có mã)
  const LIST_HTGDLHĐĐT_CMA_RADIO = [
    {
      field: INFO_DETAIL_FIELD.NNTDBKKHAN.field,
      isDisable: false,
      label:
        "Doanh nghiệp nhỏ và vừa, hợp tác xã, hộ, cá nhân kinh doanh tại địa bàn có điều kiện kinh tế xã hội khó khăn, địa bàn có điều kiện kinh tế xã hội đặc biệt khó khăn.",
    },
    {
      field: INFO_DETAIL_FIELD.NNTKTDNUBND.field,
      isDisable: false,
      label:
        "Doanh nghiệp nhỏ và vừa khác theo đề nghị của Ủy ban nhân dân tỉnh, thành phố trực thuộc Trung ương gửi Bộ Tài chính trừ doanh nghiệp hoạt động tại các khu kinh tế, khu công nghiệp, khu công nghệ cao.",
    },
  ];
  // 2. Hình thức gửi dữ liệu hóa đơn điện tử (không mã)
  const LIST_HTGDLHĐĐT_KCMA_RADIO = [
    {
      field: INFO_DETAIL_FIELD.CDLTTDCQT.field,
      label: "Chuyển dữ liệu hóa đơn điện tử trực tiếp đến cơ quan thuế.",
      isDisable:
        watch(INFO_DETAIL_FIELD.KCMA.field) === APPROVE_RADIO_VALUE.APPROVE,
    },
    {
      field: INFO_DETAIL_FIELD.CDLQTCTN.field,
      label: "Thông qua tổ chức cung cấp dịch vụ hóa đơn điện tử.",
      isDisable: false,
    },
  ];
  // 3. Phương thức chuyển dữ liệu hóa đơn điện tử:
  const LIST_PTCDL_RADIO = [
    {
      field: INFO_DETAIL_FIELD.CDDU.field,
      label: "Chuyển đầy đủ nội dung từng hóa đơn.",
      isDisable: false,
    },
    {
      field: INFO_DETAIL_FIELD.CBTHOP.field,
      label: "Chuyển theo bảng tổng hợp dữ liệu hóa đơn điện tử.",
      isDisable:
        watch(INFO_DETAIL_FIELD.CMA.field) === APPROVE_RADIO_VALUE.APPROVE,
    },
  ];

  // 4. Loại hóa đơn sử dụng:
  const LIST_LHDSD_CHECKBOX = [
    {
      field: INFO_DETAIL_FIELD.HDGTGT.field,
      label: t(`field.${INFO_DETAIL_FIELD.HDGTGT.field}`),
    },
    {
      field: INFO_DETAIL_FIELD.HDBHANG.field,
      label: t(`field.${INFO_DETAIL_FIELD.HDBHANG.field}`),
    },
    {
      field: INFO_DETAIL_FIELD.HDBTSCONG.field,
      label: t(`field.${INFO_DETAIL_FIELD.HDBTSCONG.field}`),
    },
    {
      field: INFO_DETAIL_FIELD.HDBHDTQGIA.field,
      label: t(`field.${INFO_DETAIL_FIELD.HDBHDTQGIA.field}`),
    },
    {
      field: INFO_DETAIL_FIELD.HDKHAC.field,
      label: t(`field.${INFO_DETAIL_FIELD.HDKHAC.field}`),
    },
    {
      field: INFO_DETAIL_FIELD.CTU.field,
      label: t(`field.${INFO_DETAIL_FIELD.CTU.field}`),
    },
    {
      field: INFO_DETAIL_FIELD.HDGTGTTHBLai.field,
      label: t(`field.${INFO_DETAIL_FIELD.HDGTGTTHBLai.field}`),
    },
    {
      field: INFO_DETAIL_FIELD.HDBHTHBLai.field,
      label: t(`field.${INFO_DETAIL_FIELD.HDBHTHBLai.field}`),
    },
    {
      field: INFO_DETAIL_FIELD.HDTMai.field,
      label: t(`field.${INFO_DETAIL_FIELD.HDTMai.field}`),
    },
  ];

  useEffect(() => {
    // console.log(
    //   "🚀 ~ file: DetailData.js ~ line 121 ~ useEffect ~ errors",
    //   errors
    // );
  }, [errors]);

  // START LIST_CA_FIELD
  const { fields, append, prepend, remove, swap, move, insert } = useFieldArray(
    {
      control, // control props comes from useForm (optional: if you are using FormContext)
      name: LIST_CA_FIELD.field, // unique name for your Field Array
      keyName: "key", // keyName: "id", default to "id", you can change the key name
    }
  );

  const defaultValueLine = {
    [LIST_CA_FIELD.TTCHUC.field]: undefined,
    [LIST_CA_FIELD.SERI.field]: undefined,
    [LIST_CA_FIELD.HTHUC.field]: undefined,
    [LIST_CA_FIELD.TNGAY.field]: [],
  };

  const addNewLine = () => {
    append(defaultValueLine);
  };
  // END LIST_CA_FIELD

  // START LIST_TTTCGP_FIELD
  const {
    fields: fieldsTTTCGP,
    append: appendTTTCGP,
    remove: removeTTTCGP,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: LIST_TTTCGP_FIELD.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const defaultValueLineTTTCGP = {
    [LIST_TTTCGP_FIELD.TTCGP.field]: LCS_INFO.ten,
    [LIST_TTTCGP_FIELD.MSTTCGP.field]: LCS_INFO.mst,
    [LIST_TTTCGP_FIELD.TNGAY.field]: [],
    [LIST_TTTCGP_FIELD.GCHU.field]: "",
  };

  const addNewLineTTTCGP = () => {
    appendTTTCGP(defaultValueLineTTTCGP);
  };
  // END LIST_TTTCGP_FIELD

  // START LIST_TTTCTN_FIELD
  const {
    fields: fieldsTTTCTN,
    append: appendTTTCTN,
    remove: removeTTTCTN,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: LIST_TTTCTN_FIELD.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const defaultValueLineTTTCTN = {
    [LIST_TTTCTN_FIELD.TTCTN.field]: LCS_INFO.ten,
    [LIST_TTTCTN_FIELD.MSTTCTN.field]: LCS_INFO.mst,
    [LIST_TTTCTN_FIELD.TNGAY.field]: [],
    [LIST_TTTCTN_FIELD.GCHU.field]: "",
  };

  const addNewLineTTTCTN = () => {
    appendTTTCTN(defaultValueLineTTTCTN);
  };
  // END LIST_TTTCTN_FIELD

  // START LIST_TTDVHTPT_FIELD
  const {
    fields: fieldsTTDVHTPT,
    append: appendTTDVHTPT,
    remove: removeTTDVHTPT,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: LIST_TTDVHTPT_FIELD.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const defaultValueLineTTDVHTPT = {
    [LIST_TTDVHTPT_FIELD.TDVHTPT.field]: "",
    [LIST_TTDVHTPT_FIELD.MSTDVHTPT.field]: "",
    [LIST_TTDVHTPT_FIELD.TNGAY.field]: [],
    [LIST_TTDVHTPT_FIELD.GCHU.field]: "",
  };

  const addNewLineTTDVHTPT = () => {
    appendTTDVHTPT(defaultValueLineTTDVHTPT);
  };
  // END LIST_TTDVHTPT_FIELD

  // START LIST_TTTNSDung_FIELD
  const {
    fields: fieldsTTTNSDung,
    append: appendTTTNSDung,
    remove: removeTTTNSDung,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: LIST_TTTNSDung_FIELD.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const defaultValueLineTTTNSDung = {
    [LIST_TTTNSDung_FIELD.TTCGP.field]: "",
    [LIST_TTTNSDung_FIELD.MSTTCGP.field]: "",
    [LIST_TTTNSDung_FIELD.SERI.field]: "",
    [LIST_TTTNSDung_FIELD.GCHU.field]: "",
    [LIST_TTTNSDung_FIELD.TNGAY.field]: [],
  };

  const addNewLineTTTNSDung = () => {
    appendTTTNSDung(defaultValueLineTTTNSDung);
  };
  // END LIST_TTTNSDung_FIELD

  // START LIST_TTDKTH_FIELD
  const {
    fields: fieldsTTDKTH,
    append: appendTTDKTH,
    remove: removeTTDKTH,
  } = useFieldArray({
    control, // control props comes from useForm (optional: if you are using FormContext)
    name: LIST_TTDKTH_FIELD.field, // unique name for your Field Array
    keyName: "key", // keyName: "id", default to "id", you can change the key name
  });

  const defaultValueLineTTDKTH = {
    [LIST_TTDKTH_FIELD.TLHDON.field]: "",
    [LIST_TTDKTH_FIELD.KHMSHDON.field]: null,
    [LIST_TTDKTH_FIELD.KHHDON.field]: "",
    [LIST_TTDKTH_FIELD.TEN.field]: "",
    [LIST_TTDKTH_FIELD.MST.field]: "",
    [LIST_TTDKTH_FIELD.MDICH.field]: "",
    [LIST_TTDKTH_FIELD.GCHU.field]: "",
    [LIST_TTDKTH_FIELD.TNGAY.field]: [],
  };

  const addNewLineTTDKTH = () => {
    appendTTDKTH(defaultValueLineTTDKTH);
  };
  // END LIST_TTDKTH_FIELD

  useEffect(() => {
    console.log("🚀 ~ useEffect ~ listTTDVHTPT:", listTTDVHTPT);
    console.log("🚀 ~ useEffect ~ listCAs:", listCAs);
  }, [listTTDVHTPT, listCAs]);

  const submitForm = values => {
    // console.log("🚀 ~ file: DetailData.js ~ line 605 ~ values", values);
    const finalData = formatData(values);
    console.log("🚀 ~ submitForm finalData:", finalData);
    if (dataDetail.id) {
      dispatch(editRegistryInvoices(finalData, dataDetail.id));
    } else {
      dispatch(createRegistryInvoices(finalData));
    }
  };

  const formatListData = data => {
    const listData = [];
    let stt = 0;
    for (const item of data) {
      const childData = {};
      stt = stt + 1;
      for (const keyItem in item) {
        const dataChild = item[keyItem];
        if (!dataChild) {
          continue;
        }
        childData["stt"] = stt;
        // get From Date
        if (Array.isArray(dataChild)) {
          const tngay = convertDate(dataChild[0]);
          const dngay = convertDate(dataChild[1]);
          childData["tngay"] = tngay;
          childData["dngay"] = dngay || null;
        } else if (typeof dataChild === "object" && dataChild !== null) {
          // get value from select
          childData[keyItem] = dataChild.value;
        } else {
          // get value text
          childData[keyItem] = dataChild;
        }
      }
      listData.push(childData);
    }
    return listData;
  };

  // Reset lại 2.Hình thức gửi dữ liệu HĐĐT khi change 1.Hình thức hóa đơn áp dụng
  const resetHthdRadio = () => {
    if (
      getValues(INFO_DETAIL_FIELD.CMA.field) === APPROVE_RADIO_VALUE.APPROVE
    ) {
      setValue(
        INFO_DETAIL_FIELD.CDLTTDCQT.field,
        APPROVE_RADIO_VALUE.NOT_APPROVE
      );
      setValue(
        INFO_DETAIL_FIELD.CDLQTCTN.field,
        APPROVE_RADIO_VALUE.NOT_APPROVE
      );
      setValue(
        INFO_DETAIL_FIELD.NNTDBKKHAN.field,
        APPROVE_RADIO_VALUE.NOT_APPROVE
      );
      setValue(INFO_DETAIL_FIELD.CDDU.field, APPROVE_RADIO_VALUE.APPROVE);
      setValue(INFO_DETAIL_FIELD.CBTHOP.field, APPROVE_RADIO_VALUE.NOT_APPROVE);
    } else {
      //   console.log("r");
      setValue(
        INFO_DETAIL_FIELD.NNTDBKKHAN.field,
        APPROVE_RADIO_VALUE.NOT_APPROVE
      );
      setValue(
        INFO_DETAIL_FIELD.NNTKTDNUBND.field,
        APPROVE_RADIO_VALUE.NOT_APPROVE
      );
      setValue(INFO_DETAIL_FIELD.CDLQTCTN.field, APPROVE_RADIO_VALUE.APPROVE);
      setValue(
        INFO_DETAIL_FIELD.CDLTTDCQT.field,
        APPROVE_RADIO_VALUE.NOT_APPROVE
      );
    }
  };

  const formatData = values => {
    console.log("🚀 ~ formatData values:", values);
    const finalData = {};
    for (const key in values) {
      let data = values[key];
      switch (key) {
        case LIST_CA_FIELD.field:
        case LIST_TTTCGP_FIELD.field:
        case LIST_TTTCTN_FIELD.field:
        case LIST_TTDVHTPT_FIELD.field:
        case LIST_TTTNSDung_FIELD.field:
        case LIST_TTDKTH_FIELD.field:
          finalData[key] = formatListData(data);
          break;
        default:
          //get From Date
          if (Array.isArray(data)) {
            finalData[key] = convertDate(data[0]);
          } else if (typeof data === "object" && data !== null) {
            // get value from select
            finalData[key] = data.value;
          } else {
            // get value text
            if (data === true) {
              data = 1;
            } else if (data === false) {
              data = 0;
            }
            finalData[key] = data;
          }
          break;
      }
    }
    return finalData;
  };
  const generateTable = (
    fieldContanst,
    listContanst,
    fieldsArray,
    removeFunc,
    addFunc,
    isAuto = false,
    styleTable = {}
  ) => {
    return (
      <div className="custom-table-border" style={{ ...styleTable }}>
        <Table className="table  table-bordered">
          <thead>
            <tr>
              <th className="text-center" style={{ width: "20px" }}>
                STT
              </th>
              {Object.entries(listContanst)
                .filter(([k, v]) => !v.isHide && k !== "field" && k !== "DNGAY")
                .map(([key, value]) => {
                  let header = t(`field.listCAs.${value.field}`);
                  if (key === "TNGAY") {
                    header = "Thời hạn sử dụng chứng thư số";
                  }
                  return (
                    <th
                      style={{ width: value.width }}
                      className="text-center"
                      key={key}
                    >
                      {header}
                      {value.required && (
                        <span className="text-danger"> (*)</span>
                      )}
                    </th>
                  );
                })}
              {!isAuto && <th style={{ width: "20px" }}></th>}
            </tr>
          </thead>
          <tbody>
            {fieldsArray.map((field, index) => {
              const fieldMain = fieldContanst;
              const listField = listContanst;
              const arrayField = [];
              for (const key in listField) {
                if (
                  !listField[key].isHide &&
                  key !== "field" &&
                  key !== "DNGAY"
                ) {
                  arrayField.push(key);
                }
              }
              const tdStyle = {
                display: "table-cell",
                verticalAlign: "bottom",
              };
              return (
                <tr key={index}>
                  <td>{index + 1}</td>
                  {arrayField.map(item => {
                    const itemField = listField[item];
                    let watchDisable = disableForm;
                    switch (itemField.type) {
                      case "text":
                      case "number":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateInputFieldArray(
                              t(`form.${itemField.field}`),
                              itemField.required,
                              itemField.type,
                              errors,
                              touchedFields,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.enter", {
                                    title: t(`form.${itemField.field}`),
                                  })
                                : "",
                              register,
                              watchDisable
                            )}
                          </td>
                        );
                      case "select":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateSelectFieldArray(
                              t(`form.${itemField.field}`),
                              itemField.required,
                              errors,
                              touchedFields,
                              fieldMain,
                              index,
                              itemField.field,
                              !itemField.disabled
                                ? t("placeholder.select")
                                : "",
                              watchDisable,
                              control,
                              OPTION_CA_HTHUC,
                              null,
                              "top"
                            )}
                          </td>
                        );
                      case "date":
                        return (
                          <td style={tdStyle} key={item}>
                            {generateDateFieldArray(
                              "Từ ngày",
                              "Đến ngày",
                              itemField.required,
                              errors,
                              touchedFields,
                              fieldContanst,
                              index,
                              itemField.field,
                              "DD/MM/YYYY hh - DD/MM/YYYY hh",
                              disableForm,
                              control,
                              {
                                ...optionDateLocale,
                                mode: "range",
                                enableTime: true,
                                dateFormat: "H:i",
                                time_24hr: true,
                              }
                            )}
                          </td>
                        );
                      default:
                        break;
                    }
                  })}
                  {!isAuto && (
                    <td>
                      {dataDetail?.mode !== MODE_FORM.VIEW && (
                        <React.Fragment>
                          <div className="action-icon text-center d-flex gap-2 align-items-center justify-content-center">
                            {fieldsArray.length > 1 && (
                              <i
                                onClick={() => {
                                  removeFunc(index);
                                }}
                                className="mdi mdi-trash-can  text-danger font-size-18"
                                style={{ cursor: "pointer" }}
                              />
                            )}

                            {index === fieldsArray.length - 1 && (
                              <i
                                onClick={addFunc}
                                className="fas fa-plus  text-primary label-icon"
                                style={{ cursor: "pointer" }}
                              ></i>
                            )}
                          </div>
                        </React.Fragment>
                      )}
                    </td>
                  )}
                </tr>
              );
            })}
          </tbody>
        </Table>
      </div>
    );
  };

  return (
    <Modal
      size="lg"
      contentClassName="detail-data-format"
      style={{ maxWidth: "95%" }}
      //   contentClassName="custom-modal-style"
      isOpen={isOpen}
      role="dialog"
      autoFocus={true}
      centered={true}
      className="exampleModal"
      tabIndex="-1"
      toggle={toggle}
    >
      <div className="modal-content">
        <ModalHeader toggle={toggle}>
          {t(`modal.title.${dataDetail?.mode}`)}
        </ModalHeader>
        {loadingDetail && loadListMethodSign ? (
          <ModalBody>
            <LoadingFormNormal
              countInput="3"
              countButton="1"
              formClass="row-cols-1 row-cols-md-2"
              buttonClass="justify-content-end"
              buttonColClass="col-3"
            />
          </ModalBody>
        ) : (
          <React.Fragment>
            <ModalBody>
              <div
                ref={modal}
                style={{
                  maxHeight: "74vh",
                  overflow: "auto",
                  paddingLeft: "20px",
                  paddingRight: "20px",
                }}
              >
                <div className="custom-form-heading">
                  <i className="bx bx-info-circle text-primary"></i>
                  <strong> {t("modal.title.basic")}</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-2">
                  {/* Phiên bản XML */}
                  {/* <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.PBAN.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.PBAN.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.PBAN.field}`),
                        }),
                        register,
                        true
                      )}
                    </FormGroup>
                  </Col> */}
                  {/* Tên người nộp thuế */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.TNNT.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.TNNT.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.TNNT.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>

                  {/* Tên tờ khai */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.TEN.field}`),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.TEN.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.TEN.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Hình thức */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateSelectField(
                        t(`field.${COMMON_FIELD.HTHUC.field}`),
                        true,
                        errors,
                        COMMON_FIELD.HTHUC.field,
                        t("placeholder.select"),
                        disableForm,
                        control,
                        OPTION_HTHUC
                      )}
                    </FormGroup>
                  </Col>
                  {/* Mẫu số tờ khai */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.MSO.field}`),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.MSO.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.MSO.field}`),
                        }),
                        register,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  {/* Mã số thuế */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.MST.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.MST.field,
                        "XXXXXXXXXX-XXX (10 hoặc 14 kí tự)",
                        register,
                        disableForm,
                        null,
                        control,
                        false,
                        true
                      )}
                    </FormGroup>
                  </Col>
                  <Col>
                    <Row className="row-cols-1 row-cols-md-2">
                      {/* CQT quản lý */}
                      <Col
                        style={{
                          width: "calc(100% - 250px)",
                        }}
                      >
                        {generateSelectField(
                          t(`field.${COMMON_FIELD.CQTQLY.field}`),
                          true,
                          errors,
                          COMMON_FIELD.CQTQLY.field,
                          t("placeholder.select"),
                          disableForm,
                          control,
                          OPTION_CQTQLY,
                          "auto",
                          () => {
                            const cqtqly = getValues(COMMON_FIELD.CQTQLY.field);
                            if (cqtqly?.code) {
                              setValue(
                                COMMON_FIELD.MCQTQLY.field,
                                cqtqly.code,
                                { shouldValidate: true }
                              );
                            }
                          },
                          true
                        )}
                      </Col>
                      {/* Mã CQT quản lý */}
                      <Col style={{ width: "250px" }}>
                        {generateInputField(
                          t(`field.${COMMON_FIELD.MCQTQLY.field}`),
                          true,
                          "text",
                          errors,
                          touchedFields,
                          COMMON_FIELD.MCQTQLY.field,
                          t("placeholder.enter", {
                            title: t(`field.${COMMON_FIELD.MCQTQLY.field}`),
                          }),
                          register,
                          disableForm
                        )}
                      </Col>
                    </Row>
                  </Col>
                  {/* Người liên hệ */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.NLHE.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.NLHE.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.NLHE.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa chỉ liên hệ */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DCLHE.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DCLHE.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DCLHE.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa chỉ thư điện tử */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DCTDTU.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DCTDTU.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DCTDTU.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Điện thoại liên hệ */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DTLHE.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DTLHE.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DTLHE.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Địa danh */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DDANH.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DDANH.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DDANH.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Ngày lập */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateDateField(
                        t(`field.${COMMON_FIELD.NLAP.field}`),
                        "",
                        false,
                        errors,
                        COMMON_FIELD.NLAP.field,
                        "DD/MM/YYYY",
                        true,
                        control,
                        optionDateLocale
                      )}
                    </FormGroup>
                  </Col>
                </Row>
                <Row className="row-cols-1 row-cols-md-2">
                  {/* Người đại diện pháp luật */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.TNDDPLuat.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.TNDDPLuat.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.TNDDPLuat.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Điện thoại người đại diện pháp luật */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.DTDDPLuat.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.DTDDPLuat.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.DTDDPLuat.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Căn cước công dân */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.CCCDan.field}`),
                        true,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.CCCDan.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.CCCDan.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Số hộ chiếu */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateInputField(
                        t(`field.${COMMON_FIELD.SHChieu.field}`),
                        false,
                        "text",
                        errors,
                        touchedFields,
                        COMMON_FIELD.SHChieu.field,
                        t("placeholder.enter", {
                          title: t(`field.${COMMON_FIELD.SHChieu.field}`),
                        }),
                        register,
                        disableForm
                      )}
                    </FormGroup>
                  </Col>
                  {/* Ngày sinh đại diện pháp luật */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateDateField(
                        t(`field.${COMMON_FIELD.NSDDPL.field}`),
                        "",
                        true,
                        errors,
                        COMMON_FIELD.NSDDPL.field,
                        "DD/MM/YYYY",
                        disableForm,
                        control,
                        {
                          ...optionDateLocale,
                          altFormat: "d/m/Y",
                          dateFormat: "d/m/Y",
                        }
                      )}
                    </FormGroup>
                  </Col>
                  {/* Giới tính */}
                  <Col>
                    <FormGroup className="mb-2">
                      {generateRadioField({
                        label: t(`field.${COMMON_FIELD.GTinh.field}`),
                        isRequire: true,
                        field: COMMON_FIELD.GTinh.field,
                        listData: LIST_GTinh_RADIO,
                        setValue,
                        watch,
                        register,
                        isDisable: disableForm,
                        isHide: false,
                        style: {
                          marginTop: "10px",
                        },
                      })}
                    </FormGroup>
                  </Col>
                </Row>

                <div className="custom-form-heading mt-1">
                  {/* <i className="bx bx-info-circle text-primary"></i> */}
                  <strong>1. {t("modal.title.collap1")} </strong>
                  <span className="text-danger"> (*)</span>
                </div>
                <Row className="row-cols-1 row-cols-md-1">
                  {generateRadioGroupApprove(
                    LIST_HTHD_RADIO,
                    setValue,
                    "HTHDRadio",
                    watch,
                    register,
                    disableForm,
                    false,
                    (field, value) => {
                      if (field === INFO_DETAIL_FIELD.KCMA.field) {
                        setValue(INFO_DETAIL_FIELD.CMTMTTIEN.field, false);
                      }
                      resetHthdRadio();
                    }
                  )}
                  {/* HĐ Từ MTT */}
                  {generateCheckboxGroupApprove(
                    HĐTT_CHECKBOX,
                    register,
                    disableForm,
                    null,
                    watch(INFO_DETAIL_FIELD.CMA.field) ===
                      APPROVE_RADIO_VALUE.NOT_APPROVE
                  )}
                </Row>

                <div className="custom-form-heading mt-1">
                  {/* <i className="bx bx-info-circle text-primary"></i> */}
                  <strong>2. {t("modal.title.collap2")}</strong>
                </div>
                <Row className="row-cols-1 row-cols-md-1">
                  {watch(INFO_DETAIL_FIELD.CMA.field) ===
                  APPROVE_RADIO_VALUE.APPROVE ? (
                    <Col className="mb-1 fst-italic">
                      Không cần chọn hình thức gửi dữ liệu HĐĐT
                    </Col>
                  ) : (
                    ""
                  )}
                  {generateRadioGroupApprove(
                    LIST_HTGDLHĐĐT_CMA_RADIO,
                    setValue,
                    "HTGDLHĐĐT_CMA",
                    watch,
                    register,
                    disableForm,
                    true
                  )}
                  {generateRadioGroupApprove(
                    LIST_HTGDLHĐĐT_KCMA_RADIO,
                    setValue,
                    "HTGDLHĐĐT_KCMA",
                    watch,
                    register,
                    disableForm,
                    watch(INFO_DETAIL_FIELD.KCMA.field) ===
                      APPROVE_RADIO_VALUE.NOT_APPROVE
                  )}
                </Row>
                <Row className="row-cols-1 row-cols-md-2">
                  <Col>
                    <FormGroup className="mb-2">
                      {generateRadioField({
                        label: t(`field.${INFO_DETAIL_FIELD.CQXLTSCong.field}`),
                        isRequire: true,
                        field: INFO_DETAIL_FIELD.CQXLTSCong.field,
                        listData: LIST_USED_RADIO,
                        setValue,
                        watch,
                        register,
                        isDisable: disableForm,
                        isHide: false,
                      })}
                    </FormGroup>
                  </Col>
                </Row>
                <div className="custom-form-heading mt-1">
                  {/* <i className="bx bx-info-circle text-primary"></i> */}
                  <strong>3. {t("modal.title.collap3")}</strong>
                  <span className="text-danger"> (*)</span>
                </div>
                <Row className="row-cols-1 row-cols-md-1">
                  {generateRadioGroupApprove(
                    LIST_PTCDL_RADIO,
                    setValue,
                    "LIST_PTCDL",
                    watch,
                    register,
                    disableForm
                  )}
                </Row>
                <div className="custom-form-heading mt-1">
                  {/* <i className="bx bx-info-circle text-primary"></i> */}
                  <strong>4. {t("modal.title.collap4")}</strong>
                  <span className="text-danger"> (*)</span>
                </div>
                <Row className="row-cols-1 row-cols-md-1">
                  {generateCheckboxGroupApprove(
                    LIST_LHDSD_CHECKBOX,
                    register,
                    disableForm,
                    e => {
                      setValue("checkLHDSDung", false, {
                        shouldValidate: true,
                      });
                    }
                  )}
                </Row>
                {errors["checkLHDSDung"] && (
                  <MessageFormValidate
                    error={errors["checkLHDSDung"]["message"]}
                  />
                )}
                <div className="custom-form-heading mt-1">
                  <strong>5. {t("modal.title.collap5")}</strong>
                </div>
                {listSignInfo && listSignInfo.length > 0 && !disableForm && (
                  <button
                    type="button"
                    disabled={loadListMethodSign}
                    className={`mb-2 btn btn-${
                      listSignInfo.length > 0 ? "success" : "warning"
                    }`}
                    onClick={() => {
                      remove(fields.map((_, index) => index));
                      setValue(
                        LIST_CA_FIELD.field,
                        listSignInfo.map(
                          item => {
                            return {
                              ttchuc: item.company_name
                                ? item.company_name
                                : undefined,
                              seri: item.serial_num
                                ? item.serial_num
                                : undefined,
                              tngay: [
                                new Date(item.issued_time),
                                new Date(item.expired_time),
                              ],
                              hthuc: undefined,
                            };
                          },
                          { shouldValidate: true }
                        )
                      );
                    }}
                  >
                    <i
                      className={`${
                        loadListMethodSign
                          ? "bx bx-loader bx-spin"
                          : "fa fa-exclamation-circle"
                      } font-size-16 align-middle me-2`}
                    ></i>
                    {listSignInfo.length === 0
                      ? "Chưa có thông tin"
                      : "Load thông tin chứng thư số mặc định"}
                  </button>
                )}

                {generateTable(
                  LIST_CA_FIELD.field,
                  LIST_CA_FIELD,
                  fields,
                  remove,
                  addNewLine
                )}

                <div className="custom-form-heading mt-1">
                  <strong>6. {t("modal.title.collapTTTCGP")}</strong>
                </div>
                {generateTableV2({
                  isShowButton: false,
                  fieldConstant: LIST_TTTCGP_FIELD.field,
                  listConstant: LIST_TTTCGP_FIELD,
                  fieldsArray: fieldsTTTCGP,
                  removeFunc: removeTTTCGP,
                  addFunc: addNewLineTTTCGP,
                  isAuto: false,
                  styleTable: {},
                  t,
                  disableForm,
                  touchedFields,
                  register,
                  errors,
                  mode: dataDetail?.mode,
                  optionDateLocale,
                  control,
                })}

                <div className="custom-form-heading mt-1">
                  <strong>7. {t("modal.title.collapTTTCTN")}</strong>
                </div>
                {generateTableV2({
                  isShowButton: false,
                  fieldConstant: LIST_TTTCTN_FIELD.field,
                  listConstant: LIST_TTTCTN_FIELD,
                  fieldsArray: fieldsTTTCTN,
                  removeFunc: removeTTTCTN,
                  addFunc: addNewLineTTTCTN,
                  isAuto: false,
                  styleTable: {},
                  t,
                  disableForm,
                  touchedFields,
                  register,
                  errors,
                  mode: dataDetail?.mode,
                  optionDateLocale,
                  control,
                })}

                <div className="custom-form-heading mt-1">
                  <strong>8. {t("modal.title.collapTTDVHTPT")}</strong>
                </div>
                {generateTableV2({
                  fieldConstant: LIST_TTDVHTPT_FIELD.field,
                  listConstant: LIST_TTDVHTPT_FIELD,
                  fieldsArray: fieldsTTDVHTPT,
                  removeFunc: removeTTDVHTPT,
                  addFunc: addNewLineTTDVHTPT,
                  isAuto: false,
                  styleTable: {},
                  t,
                  disableForm,
                  touchedFields,
                  register,
                  errors,
                  mode: dataDetail?.mode,
                  optionDateLocale,
                  control,
                })}

                <div className="custom-form-heading mt-1">
                  <strong>9. {t("modal.title.collapTTTNSDung")}</strong>
                </div>
                {generateTableV2({
                  fieldConstant: LIST_TTTNSDung_FIELD.field,
                  listConstant: LIST_TTTNSDung_FIELD,
                  fieldsArray: fieldsTTTNSDung,
                  removeFunc: removeTTTNSDung,
                  addFunc: addNewLineTTTNSDung,
                  isAuto: false,
                  styleTable: {},
                  t,
                  disableForm,
                  touchedFields,
                  register,
                  errors,
                  mode: dataDetail?.mode,
                  optionDateLocale,
                  control,
                })}

                <div className="custom-form-heading mt-1">
                  <strong>10. {t("modal.title.collapTTDKTH")}</strong>
                </div>
                {generateTableV2({
                  fieldConstant: LIST_TTDKTH_FIELD.field,
                  listConstant: LIST_TTDKTH_FIELD,
                  fieldsArray: fieldsTTDKTH,
                  removeFunc: removeTTDKTH,
                  addFunc: addNewLineTTDKTH,
                  isAuto: false,
                  styleTable: {},
                  t,
                  disableForm,
                  touchedFields,
                  register,
                  errors,
                  mode: dataDetail?.mode,
                  optionDateLocale,
                  control,
                })}
              </div>
            </ModalBody>
            <ModalFooter>
              <React.Fragment>
                {(dataDetail?.mode === MODE_FORM.ADD ||
                  dataDetail?.mode === MODE_FORM.EDIT) && (
                  <Button
                    type="button"
                    color={
                      dataDetail?.mode === MODE_FORM.ADD ? "primary" : "success"
                    }
                    className="btn-label"
                    disabled={loadingSubmitCreate || loadingSubmitEdit}
                    onClick={handleSubmit(submitForm)}
                  >
                    <i className="fas fa-save label-icon"></i>
                    {t(`button.${dataDetail?.mode}`)}
                  </Button>
                )}

                {disableForm && detailRegistryInvoices?.resource_id && (
                  <Dropdown
                    direction="up"
                    isOpen={dropdownOpen}
                    toggle={toggleDropdown}
                  >
                    <DropdownToggle caret>
                      Download PDF <i className="fas fa-chevron-up"></i>
                    </DropdownToggle>
                    <DropdownMenu className="download-dropdown">
                      <DropdownItem
                        onClick={() => {
                          dispatch(
                            previewPdfRegisterInvoice(
                              detailRegistryInvoices?.id
                            )
                          );
                        }}
                      >
                        Bản hiển thị tờ khai
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          dispatch(
                            downloadPDFInvoices(
                              detailRegistryInvoices?.id,
                              detailRegistryInvoices?.ten,
                              "approve-pdf"
                            )
                          );
                        }}
                      >
                        Chấp nhận / Không chấp nhận tờ khai
                      </DropdownItem>
                      <DropdownItem
                        onClick={() => {
                          dispatch(
                            downloadPDFInvoices(
                              detailRegistryInvoices?.id,
                              detailRegistryInvoices?.ten,
                              "confirm-pdf"
                            )
                          );
                        }}
                      >
                        Tiếp nhận / Không tiếp nhận tờ khai
                      </DropdownItem>
                    </DropdownMenu>
                  </Dropdown>
                )}
                {disableForm && detailRegistryInvoices?.resource_id && (
                  <Button
                    type="button"
                    color="primary"
                    className="btn-label"
                    onClick={() => {
                      dispatch(
                        downloadXmlRegistryInvoices(
                          detailRegistryInvoices?.resource_id,
                          detailRegistryInvoices?.ten
                        )
                      );
                    }}
                  >
                    <i className="bx bx-download label-icon"></i>
                    Download XML
                  </Button>
                )}
              </React.Fragment>
            </ModalFooter>
          </React.Fragment>
        )}
      </div>
    </Modal>
  );
};

DetailData.propTypes = {
  toggle: PropTypes.func,
  toggleReleaseModal: PropTypes.func,
  isOpen: PropTypes.bool,
  dataDetail: PropTypes.object,
  t: PropTypes.any,
  i18n: PropTypes.any,
};

export default DetailData;
